import "./instructions.scss";
import React from "react";
import { graphql, StaticQuery } from "gatsby";
import FileContainer from "@components/file/file.container";

const instructions = [
	{
		name: "Памятка по работе сервиса Автоплатеж для транспортной карты",
		path: "/assets/terms-of-use/instructions autopay.pdf"
	},
	{
		name:
			"Памятка клиента по возврату денежного ресурса (денежных средств) с транспортной карты",
		path: "/assets/terms-of-use/Pamyatka_po_vozvratu.doc"
	},
	{
		name: "Правила пользования Электронным проездным билетом",
		path: "/assets/terms-of-use/Pravila_polzovaniya_EK.doc"
	},
	{
		name:
			'Инструкция процедуры пополнения транспортных карт на банкоматах "Ак Барс" Банка',
		path: "/assets/terms-of-use/instr_ak_bars_bankomats.pdf"
	},
	{
		name:
			'Инструкция процедуры пополнения транспортных карт на терминалах "Элекснет"',
		path: "/assets/terms-of-use/instr_elecsnet.pdf"
	},
	{
		name:
			"Инструкция действия кондуктора в случае выхода из строя транспортного средства",
		path: "/assets/terms-of-use/Transplantation.doc"
	},
	{
		name:
			'Постановление Руководителя Исполнительного комитета Муниципального образования г.Казани от 30.05.2008г. № 2462 "О введении электронного проездного билета и электронного единого именного социального проездного билета в г.Казани"',
		path: "/assets/terms-of-use/EPB.doc"
	}
];

const Instructions = ({ data }) => {
	const { files: { edges: files } = {} } = data;
	let i = 0;
	return (
		<section className="full-width instructions">
			<div className="grid-container">
				<div className="row">
					<div className="col-xs-12 col-md-offset-2 col-md-8 col-sm-offset-1 col-sm-10">
						<h2 className="instructions__header">Как пользоваться</h2>
					</div>
				</div>
			</div>

			<div className="grid-container">
				<div className="row">
					{instructions.map(instruction => {
						i += 1;
						return (
							<div
								key={i}
								className={`col-xs-12 ${
									i % 2
										? "col-md-offset-2 col-md-4 col-sm-offset-1 col-sm-5"
										: "col-md-4 col-sm-5"
								}`}
							>
								<FileContainer
									className="instructions__file"
									name={instruction.name}
									path={instruction.path}
									files={files}
								/>
							</div>
						);
					})}
				</div>
			</div>
		</section>
	);
};

export default props => (
	<StaticQuery
		query={graphql`
			query {
				files: allFile(
					filter: {
						extension: { regex: "/pdf|docx|doc|xlsx|xls/" }
						relativePath: { regex: "/terms-of-use/" }
					}
				) {
					edges {
						node {
							name
							relativePath
							prettySize
							root
							sourceInstanceName
							base
							birthTime
							ext
							extension
						}
					}
				}
			}
		`}
		render={data => <Instructions data={data} {...props} />}
	/>
);
